import { PlatformFirebase } from "../cloud/firebase/database/firebase-database";

/**
 * See: https://firebase.google.com/docs/reference/js/firebase.database#.enableLogging
 * @param enable Logging enabled if true.
 */
export function enableLogging(enable: boolean): void {
  PlatformFirebase.database.enableLogging(enable);
}
